import { Injectable } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private loadedScripts = new Map<string, Promise<void>>();

  constructor() {}

  getTenantForHostname(hostname: string) {
    return this.getTenantForHost(hostname.split(".")[0]);    
  }

  getTenantForHost(host: string): any {
    return host;
  } 

  getTenant() {
    return this.getTenantForHostname(location.hostname);
  }

  addTenantToHeaders(headers: HttpHeaders): HttpHeaders {
    return headers.append("X-Tenant-ID", this.getTenant());
  }

  loadTenantStyles(client: any): Promise<void> {
    const scriptUrl = client?.jsUrl;
    const key = scriptUrl || '_no_js_';

    if (this.loadedScripts.has(key)) {
      return this.loadedScripts.get(key)!;
    }

    const promise = new Promise<void>((resolve) => {
      const styleUrl = client?.styleUrl;
      let resolved = false;
      const doResolve = () => { if (!resolved) { resolved = true; resolve(); } };

      if (styleUrl) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = styleUrl;
        document.head.appendChild(link);
      }

      if (scriptUrl) {
        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        script.onload = doResolve;
        script.onerror = doResolve;
        document.head.appendChild(script);
        setTimeout(doResolve, 5000);
      } else {
        doResolve();
      }
    });

    this.loadedScripts.set(key, promise);
    return promise;
  }
}